var CryptoJS = require("crypto-js");
var password = "UcK*hCW(7qcf{N3d";
const CryptoJSAesJson = {
    'stringify': function (cipherParams) {
      var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) }
      if (cipherParams.iv) j.iv = cipherParams.iv.toString()
      if (cipherParams.salt) j.s = cipherParams.salt.toString()
      return JSON.stringify(j).replace(/\s/g, '')
    },
    'parse': function (jsonStr) {
      var j = JSON.parse(jsonStr)
      var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
      if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams
    }
  }

module.exports.setPassword = (pass)=>{
    if(pass){
        password = pass; 
    }else{
        return "Invalid password";
    }
}
module.exports.encode = (data,pass=password)=>{
    let encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), pass, { format: CryptoJSAesJson }).toString()
    return encrypted;
}
module.exports.decode = (encrypted,pass=password)=>{
    let isError = false;
    switch (typeof encrypted) {
        case "string":
            if(!(encrypted.match(/"ct"/) && encrypted.match(/"iv"/) && encrypted.match(/"s"/))){
                isError = true;
            }
            break;
        case "object":
            if(!(encrypted.hasOwnProperty("ct")&& encrypted.hasOwnProperty("iv")&& encrypted.hasOwnProperty("s"))){
                isError = true;
            }else{
                encrypted = JSON.stringify(encrypted);
            }
            break;    
        default:
            isError = true
            break;
    }
    if(isError){
        return "Invalid encoded format";
    }
    try {
        let decrypted = CryptoJS.AES.decrypt(encrypted, pass, { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8)
        return  JSON.parse(decrypted); 
    } catch (error) {  
        return "error in decoding";
    }
}